import { combineReducers } from "@reduxjs/toolkit";

import { reducer as damagesReducer } from "../features/OC/Vehicle/Damages/damages.slice";
import { reducer as incidentReducer } from "../features/OC/Vehicle/Incident/incident.slice";
import { reducer as introductoryReducer } from "../features/OC/Vehicle/Introductory/introductory.slice";
import { reducer as summaryReducer } from "../features/OC/Vehicle/Summary/summary.slice";
import { reducer as vehicleOwnerReducer } from "../features/OC/Vehicle/VehicleOwner/vehicleOwner.slice";

export const ocVehicleFormReducer = combineReducers({
  introductory: introductoryReducer,
  incident: incidentReducer,
  vehicleOwner: vehicleOwnerReducer,
  damages: damagesReducer,
  summary: summaryReducer,
});
